// Import .less entry point
import '../assets/private/stylesheets/account/_account.less';
import './customer/styles/style';

/** specific country imports */
import { init as initCountrySpecific} from '@/_override/customer/customer-country.entry';
import '@/_override/customer/customer-country.less';
/** end of specific country imports */


import { init as initDashboard } from './customer/account/account-dashboard';
import { init as initAccountNavigation } from './customer/account/account-navigation';
import { init as initAccountConsent } from './customer/account/account-consent';
import { init as initAccountSubscriptions } from './customer/account/account-subscriptions';
import { init as initAccountLanguage } from './customer/account/account-language';
import { init as initProductReturn } from './customer/account/returns/product-return';
import { init as initAccountMembershipBenefits } from './customer/account/account-membership-benefits';
import { init as initAccountBarcode } from './customer/account/account-barcode';
import { init as initAccountProfile } from './customer/account/account-profile';
import { init as initAccountAddressBook } from './customer/account/account-address-book';
import { init as initCustomerPassword } from './customer/customer-password';
import { initMyStorePage, initMyStoreBlock } from './customer/account/account-store';

// Import analytics
import { init as initAnalytics } from './analytics/routes/customer.anly.route';


document.addEventListener('DOMContentLoaded', () => {
  // ACCOUNT //
  if (cube.$id('dashboard-account-nav')) initAccountNavigation();
  if (cube.$id('account')) initDashboard();
  if (cube.$id('my-consent')) initAccountConsent();
  if (cube.$id('my-subscriptions')) initAccountSubscriptions();
  if (cube.$id('my-language')) initAccountLanguage();
  if (cube.$('.account.return')) initProductReturn();
  if (cube.$id('my-profile')) initAccountProfile();
  if (cube.$id('js-address-book')) initAccountAddressBook();
  if (cube.$('.js-password')) initCustomerPassword();
  if (cube.$id('mystore-page')) initMyStorePage();
  if (cube.$('[data-tracking="card-my-store"]')) initMyStoreBlock();

  if (cube.$id('my-membership-benefits')) {
    initAccountBarcode();
    initAccountMembershipBenefits();
  }

  /*
  Returns screens management : particular case, the code is also used in the checkout scope
  so we import what we need dynamically
  */
  if (cube.$('body.checkout-delivery')) {
    Promise.all([
      import(/* webpackChunkName: "shipping" */ './modules-es5/checkout/shipping/shipping'),
      import(/* webpackChunkName: "billingAddress" */ './modules-es5/checkout/billingAddress'),
    ]).then(([shipping, billingAddress]) => {
      shipping.init();
      billingAddress.init();
    });
  }

  const customerWallet = cube.$id('customer-wallet');
  if (customerWallet) {
    import(/* webpackChunkName: "wallet" */ './modules-es5/account/order/Wallet').then(
      ({ Wallet }) => {
        const walletModule = new Wallet();
        walletModule.init({
          container: customerWallet
        });
      }
    );
  }

  if (cube.$id('my-refunds')) {
    import(/* webpackChunkName: "refunds" */ './modules-es5/account/refunds/refunds-list').then(
      ({ RefundsList }) => {
        const list = new RefundsList();
        list.init();
      });
  }

  // Return itInSell
  if (cube.$id('itinsell-return-btn')) {
    import(/* webpackChunkName: "itInSell" */ './customer/return/itInSell.js').then(itInSell => itInSell.init());
  }

  initCountrySpecific();
  initAnalytics();
});



// WEBPACK FOOTER //
// ./src/customer.route.js